import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {merge, Observable, of} from 'rxjs';
import {catchError, filter, map, mergeMap, take, timeout} from 'rxjs/operators';
import {OAuthResourceServerErrorHandler, OAuthService} from 'angular-oauth2-oidc';
import {SessionService} from "../services";

@Injectable({providedIn: 'root'})
export class ApiInterceptor implements HttpInterceptor {
    constructor(private oAuthService: OAuthService,
                private errorHandler: OAuthResourceServerErrorHandler,
                private sessionService: SessionService,) {
    }

    public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (!req.url.toLowerCase().includes('api/v')) {
            return next.handle(req);
        }

        const apiKey = this.sessionService.getXApiKey();
        if (apiKey) {
            // Use ApiKey Auth
            const headers = req.headers.set('x-api-key', apiKey);
            req = req.clone({headers});
            return next.handle(req).pipe(catchError(err => this.errorHandler.handleError(err)));
        } else {
            // Use Keycloak auth
            return merge(
                this.oAuthService.events.pipe(
                    filter(e => e.type === 'token_received'),
                    timeout(this.oAuthService.waitForTokenInMsec || 0),
                    catchError(_ => of(null)), // timeout is not an error
                    map(_ => this.oAuthService.getAccessToken())
                )
            ).pipe(
                take(1),
                mergeMap(token => {
                    if ( token ) {
                        const headers = req.headers.set('Authorization', 'Bearer ' + token);
                        req = req.clone({ headers });
                    }
                    return next.handle(req).pipe(catchError(err => this.errorHandler.handleError(err)));
                })
            );
        }
    }
}
